import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';


import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Select from './Select';

export default function ScheduleInputs(props) {

    const { 
        showtype=0,
        setbuttonFlag=() => {},
        buttonFlag,
        setsely=() => {},
        setselm=() => {},
        setseld=() => {},
        setselsh=() => {},
        setselsmin=() => {},
        setseleh=() => {},
        setselemin=() => {},
        sely='',
        selm='',
        seld='',
        selsh='',
        selsmin='',
        seleh='',
        selemin='',
    } = props;


    const dispatch = useDispatch();
    const navigate = useNavigate();
    

    let yearDatas = [];
    let monthDatas = [];
    let dayDatas = [];
    let hourDatas = [];
    let minDatas = [];
    //{labels: '선택하세요', values: ''}
    let starty = moment().add(-5, 'Y').format('YYYY');
    let endy = moment().add(+5, 'Y').format('YYYY');
    for(let y = starty; y <= endy; y++){
        yearDatas.push({labels: y+'년', values: y+''});
    }
    for(let m = 1; m <= 31; m++){
        let monthtxt = m < 10 ? '0'+m : m;
        monthDatas.push({labels: monthtxt+'월', values: monthtxt+''});
    }
    for(let d = 1; d <= 31; d++){
        let daytxt = d < 10 ? '0'+d : d;
        dayDatas.push({labels: daytxt+'일', values: daytxt+''});
    }    
    for(let h = 0; h <= 23; h++){
        let txt = h < 10 ? '0'+h : h;
        hourDatas.push({labels: txt+'', values: txt+''});
    }    
    for(let m = 0; m <= 59; m++){
        let txt = m < 10 ? '0'+m : m;
        if(m%5 === 0){
            minDatas.push({labels: txt+'', values: txt+''});
        }
    }    

    useEffect(() => {
        let dates = `${sely}-${selm}-${seld} ${selsh}:${selsmin}:00`;
        if(selsh*1 === 23){
            setseleh('23');
        } else {
            setseleh(moment(dates).add(+1, 'H').format('HH'));
        }
    }, [selsh]);
    
    return (
        <>
            <div className='datesel'>
                <div>
                    <Select 
                        setValues={setsely}
                        values={sely}
                        selectData={yearDatas}
                    />                                                  
                </div>
                <div>
                    <Select 
                        setValues={setselm}
                        values={selm}
                        selectData={monthDatas}
                    />                                                        
                </div>
                <div>
                    <Select 
                        setValues={setseld}
                        values={seld}
                        selectData={dayDatas}
                    />                                                       
                </div>                                                                                        
            </div>
            <div className='datetimesel'>
                <div>
                    <Select 
                        selectClass={'timeSelect'}
                        setValues={setselsh}
                        values={selsh}
                        selectData={hourDatas}
                    />
                    :
                    <Select 
                        selectClass={'timeSelect'}
                        setValues={setselsmin}
                        values={selsmin}
                        selectData={minDatas}
                    />                                        
                </div>
                {buttonFlag === false && showtype === 0 &&
                <>
                <div>~</div>
                <div>
                    <Select 
                        selectClass={'timeSelect'}
                        setValues={setseleh}
                        values={seleh}
                        selectData={hourDatas}
                    />
                    :
                    <Select 
                        selectClass={'timeSelect'}
                        setValues={setselemin}
                        values={selemin}
                        selectData={minDatas}
                    />                                        
                </div>
                </>}
            </div>
            {buttonFlag === false && showtype === 0 &&
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                <button
                    style={{
                        borderRadius: 100, width: 100, height: 36, border: '1px solid #CCC', gap: 4,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6164A5', fontWeight: 700
                    }}
                    onClick={() => {
                            setbuttonFlag(showtype === 0 ? true : false);
                        
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                        <path d="M9.16602 9.6665V4.6665H10.8327V9.6665H15.8327V11.3332H10.8327V16.3332H9.16602V11.3332H4.16602V9.6665H9.16602Z" fill="#6164A5"/>
                    </svg>
                    기간 선택
                </button>
            </div>
            }
            {buttonFlag === true && showtype === 1 &&
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                <button
                    style={{
                        borderRadius: 100, width: 100, height: 36, border: '1px solid #CCC', gap: 4,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#F00', fontWeight: 700
                    }}
                    onClick={() => {
                            setbuttonFlag(false);
                        
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                        <path d="M4.16602 9.6665V11.3332H15.8327V9.6665H4.16602Z" fill="#FF0000"/>
                    </svg>
                    기간 삭제
                </button>
            </div>
            }

        </>
    )    
}